export const piqStyles: string = `
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&display=swap');

.input {
  border: 2px solid var(--components-input-border, #CCE1DB) !important;
}

.input::placeholder {
   color: var(--components-input-fg-primary, #0A0A0A) !important;
}

.input-wrapper {
  border-radius: 48px;
}

.input-wrapper input {
  padding-left: 18px !important;
}

.input-label-float {
  padding-left: 8px !important;
}

.input-wrapper .input-label-float {
  top: 50% !important;
}

.input-wrapper .input-label-float.active {
  margin-top: 8px !important;
}

.input-wrapper .input-label-float.active+input {
  padding-top: 16px !important;
  padding-left: 14px !important;
}

#cashier .submit-button {
  color: var(--components-button-primary-fg, #03110D) !important;
}

.btn {
  padding-top: unset !important;
  padding-bottom: unset !important;
  height: 48px !important;
  font-size: 18px !important;
}

.disabled-overlay,
.submit-button-container .submit-button {
  margin-top: 8px !important;
}

.set-amount .predefinedvalues {
  margin: 0;
  gap: 8px;
}

.set-amount .predefinedvalues > * {
  padding: 0 !important;
  min-width: 29% !important;
}

.set-amount .predefinedvalues button {
  height: 32px !important;
  padding: 0 10px !important;
  border-radius: 32px !important;
  background: var(--components-tag-bg, #CCE1DB) !important;
  color: var(--components-tag-text, #03110D) !important;
}

.set-amount .predefinedvalues button.active {
  background: var(--components-tag-bg-active, #0c3b2e) !important;
  color: var(--components-tag-text-active, #ecf3f1) !important;
}

.payment-method-collection {
  display: flex;
  align-items: center;
  border-radius: 24px;
}

.payment-method {
 background: var(--background-secondary, #ecf3f1);
 border-radius: 16px;
 transition: background .2s ease !important;
}

.payment-method-details {
  margin: 0 4px 4px;
  background: var(--background-primary, #FFF) !important;
  padding: 16px !important;
  border-radius: 12px;
}

.list-payment-methods {
  margin-bottom: 0 !important;
}

.list-payment-methods__list {
  display: grid;
  gap: 8px;
}

.logo-container {
  overflow: hidden;
  display: flex;
  justify-content: center !important;
  align-items: center;
  width: 48px !important;
  height: 48px !important;
  background: var(--background-primary, #FFF);
  border-radius: 16px;
  order: -1;
}

.logo-container .logo-icon {
  margin: auto;
  max-width: calc(100% - 16px) !important;
  max-height: calc(100% - 16px) !important;
  object-fit: contain;
}

.payment-method .payment-method-header .label-container {
  padding: 0 !important;
  margin-left: 8px !important;
  min-height: auto !important;
}

.payment-method .payment-method-header:before {
  display: none;
}

.payment-method-header {
  padding: 0 16px !important;
  min-height: 80px;
}

.payment-method-label {
  margin: 0 !important;
}

.payment-method.active .payment-method-header:after {
  margin: 0 !important;
  top: calc(50% - 4px) !important;
  right: 30px;
  width: 8px !important;
  height: 8px !important;
  transform: none !important;
}

.dropdown-toggler {
  border-radius: 48px !important;
  border: 1px solid #D6D6D6 !important;
  height: 48px !important;
  padding: 10px 18px !important
}

.dropdown-content {
  border-radius: 24px !important;
  background-color: #fff !important;
}

.dropdown.open .dropdown-container .dropdown-toggler {
    z-index: 1001;
    position: relative;
    margin: 0 8px;
    width: calc(100% - 16px);
    transform: translateY(8px);
}

.dropdown.open .dropdown-container .dropdown-content {
  top: 0;
  padding: 60px 10px 0;
}

.dropdown.open .dropdown-container .dropdown-content::-webkit-scrollbar {
  background-color: rgba(0,0,0,0);
}

.dropdown.open .dropdown-container::before {
  position: absolute;
  z-index: 1001;
  display: inline-block;
  top: 0;
  left: 0;
  width: calc(100% - 16px);
  height: 60px;
  border-radius: 32px 32px 0 0;
  background: #fff;
  content: ' ';
}


.dropdown .dropdown-container .dropdown-content {
  transition: unset !important;
  -webkit-transition: unset !important;
}

.notice-container {
  align-items: center !important;
}

.notice-container .ion-icon-left,
.notice-container .ion-icon-right {
  position: static;
  display: flex;
}

.notice-container .ion-icon-left {
  order: 1;
}

.notice-container div {
  order: 2;
}

.notice-container .ion-icon-right {
  order: 3;
}

.notice-container .ion-icon-left .notice-alert {
  padding: 0;
}

.footer-left back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 var(--space-4);
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
  font-family: 'Poppins';
  border-radius: 48px;
  background: var(--components-button-quaternary-bg, #D6D6D6);
}

.generic-inputs-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.generic-inputs-container-multiple .inputs-wrapper:nth-child(n+3) {
  margin-top: 0px;
}

.generic-inputs-container-multiple .inputs-wrapper{
  width: 100% !important;
}
`;
